import { Link } from 'react-router-dom';
import { useHeadlineStore } from '../stores/headlineStore';
import type { Source } from '../types';

interface Props {
  sources: Source[];
  hiddenIds: number[];
  activeSlug: string | null | undefined;
}

export default function SourceNav({ sources, hiddenIds, activeSlug }: Props) {
  const visible = sources.filter((s) => !hiddenIds.includes(s.id));
  const fetchHeadlines = useHeadlineStore((s) => s.fetchHeadlines);

  const handleClick = (e: React.MouseEvent, slug: string | null) => {
    if (activeSlug === undefined) return; // on classifier page, navigate normally
    const currentSlug = activeSlug;
    if (slug === currentSlug) {
      e.preventDefault();
      fetchHeadlines({ sourceSlug: slug ?? undefined });
    } else if (slug === null && currentSlug === null) {
      e.preventDefault();
      fetchHeadlines();
    }
  };

  return (
    <nav>
      {visible.map((s) => (
        <Link
          key={s.id}
          to={`/source/${s.slug}`}
          className={activeSlug === s.slug ? 'active' : ''}
          onClick={(e) => handleClick(e, s.slug)}
        >
          {s.name}
        </Link>
      ))}
      <Link
        to="/all"
        className={activeSlug === null ? 'active' : ''}
        onClick={(e) => handleClick(e, null)}
      >
        All
      </Link>
    </nav>
  );
}
